import React, { ChangeEventHandler, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { Loader } from '@ti8m/paas-ui';

interface Props {
  hitCounts?: number;
  onChange: ChangeEventHandler<HTMLInputElement>;
  resultsLoading: boolean;
  searchOpen: boolean;
  searchValue: string;
}

const SearchField: React.FC<Props> = ({ hitCounts, onChange, resultsLoading, searchValue }: Props) => {
  const { formatMessage: f } = useIntl();

  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleTransitionEnd = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  useEffect(() => {
    const searchOverlay = document.getElementById('search-overlay');

    if (searchOverlay) {
      searchOverlay.addEventListener('transitionend', () => handleTransitionEnd());
      return searchOverlay.removeEventListener('transitionend', () => handleTransitionEnd());
    }
  }, []);

  return (
    <Row>
      <Col xs={12} className={'search-input-group'}>
        <label htmlFor={'search-query'} className={'sr-only'}>
          {f({ id: 'search.placeholder' })}
        </label>
        <input
          ref={inputRef}
          id="search-query"
          type="text"
          className="search-input"
          placeholder={f({ id: 'search.placeholder' })}
          maxLength={128}
          value={searchValue}
          autoComplete="off"
          required
          onChange={onChange}
        />
      </Col>

      <Col xs={12} className={'search-no-results-found form-text d-block'}>
        {resultsLoading && <Loader />}
        {!resultsLoading && searchValue.length > 0 && hitCounts === 0 && <span>{f({ id: 'search.noresults' })}</span>}
      </Col>
    </Row>
  );
};

export default SearchField;
